import React, { useEffect, useState } from 'react'
import ReusableDiv from 'src/support/ReusableDiv'
import System from 'src/helper/system'
import Helper from 'src/support/Helper'
import Auth from "@system/config/auth";
import axios from "axios";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { __remove, __set } from "src/store/axios_indicator";
import { useDesignHubStore } from "src/hooks/designHub";
import Constants from "src/support/Constants";
import DOMAttachToSystem from 'src/captain/DOMAttachToSystem';
import liveAuth from "src/helper/liveAuth";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";

const Registration = () => {
    const [detailValidation, setDetailValidation] = useState({});
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [__check] = useAxiosIndicatorCheck();
    const [{ countryList }, { get_country_list }, { register_user }] = useDesignHubStore();

    const modal = {
        company_name: "",
        telephone_number: "",
        first_name: "",
        last_name: "",
        email_address: "",
        speedboat: System.getCurrentSiteSpeedboatShortName(),
        email_updates: false,
        country: "",
        mkto_trk: Helper.getCookie("_mkto_trk") || "",
        allow_design_bom: false,
        privacy_policy: false
    }
    const [userDetail, setUserDetail] = useState(modal);
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailSpecialCharPattern = /^[a-zA-Z0-9\-\.\_\@\$\%\+]+$/;
    const [confirmEmail, setConfirmEmail] = useState("")

    useEffect(() => {
        registerationEvent("start");
        formEvent("formStartEvent");
        setFirstServerCall(false)
        get_country_list()
    }, [])

    useEffect(()=> {
        if (firstServerCall === false && !liveAuth.check()) {
            Helper.monitorJSDx()
        }
    }, [countryList])

    const onValueChange = (field, value) => {
        if (detailValidation && Object.keys(detailValidation).length > 0) {
            field === 'confirmEmail' ? delete detailValidation.confirm_email : delete detailValidation[field]
        }
        field === 'confirmEmail' ? setConfirmEmail(value) : setUserDetail({ ...userDetail, [field]: value });
    }

    const onValidateData = () => {
        let validationModal = {}
        Helper.valueIsNotNull(userDetail.company_name) ? "" : validationModal.company_name = "Please enter company name.";
        Helper.valueIsNotNull(userDetail.telephone_number) ? "" : validationModal.telephone_number = "Please enter phone number.";
        Helper.valueIsNotNull(userDetail.first_name) ? "" : validationModal.first_name = "Please enter first name.";
        Helper.valueIsNotNull(userDetail.last_name) ? "" : validationModal.last_name = "Please enter last name.";
        Helper.valueIsNotNull(userDetail.country) ? "" : validationModal.country = "Please Select Country.";
        userDetail.privacy_policy === true ? "" : validationModal.privacy_policy = "Please select this checkbox";
        Helper.valueIsNotNull(confirmEmail) ? (userDetail?.email_address?.toLocaleLowerCase() === confirmEmail?.toLocaleLowerCase() ? '' : validationModal.confirm_email = 'Your emails do not match. Please re-enter.') :
            validationModal.confirm_email = 'Please enter email address.'

        if (Helper.valueIsNotNull(userDetail.email_address)) {
            if (!Helper.validateRegex(userDetail.email_address, emailPattern)) {
                validationModal.email_address = 'Invalid Email, Please enter valid Email Address.'
            } else {
                if (!Helper.validateRegex(userDetail.email_address, emailSpecialCharPattern)) {
                    validationModal.email_address = 'Valid characters include A-z, 0-9, and (-._@$%+)'
                }
            }
        } else {
            validationModal.email_address = "Please enter email address."
        }

        setDetailValidation(validationModal)
        return Object.keys(validationModal).length > 0 ? false : true;
    }

    const onSubmit = async () => {
        let isValid = onValidateData();

        if (isValid) {
            __set('REGISTRATION_API_CALL')
            let validationModal = {}

            const res = await register_user(userDetail)
            if (res && res.isSuccessFull) {
                System.popup('ThankYouPopup', { isRegister: true });
                registerationEvent("complete",res);
            } else if (res?.errorCode === Constants.errorCode) {
                validationModal.email_address = 'This account already exists. Please enter a new email address.'
                setDetailValidation(validationModal)
            } else {
                if (res && res.ErrorCode && res.Message) {
                    if (res?.ErrorCode === '422') {
                        validationModal.email_address = "Please use your windows credentials to login to the " + System.getSpeeBboat()
                        setDetailValidation(validationModal)
                    }
                }
            }
            __remove('REGISTRATION_API_CALL')
        }
        else {
            formEvent("formErrorEvent");
        }
    }

    //By Ramya Kannan [Registeration start,complete - Adobe script ]
    function registerationEvent(type,res){
         let registrationType = type == "start" ? "registrationStart" : "registrationComplete";
         localStorage.setItem("adobeEventType",registrationType);
        HelperAdobeEvent.trackingAdobeEvent(res);
    }
    
    //By Ramya Kannan [form start,Error event - Adobe script]
    function formEvent(eventType){
        localStorage.setItem("adobeEventType",eventType);
        let formDetails = {
            formName : "Register",
            formType : "",
            formId : ""
        }
        HelperAdobeEvent.trackingAdobeEvent({formDetails});
    }
    

    return (
        <div>
            {process.env.NODE_ENV !== "development" && <DOMAttachToSystem />}
            <div className='register-container'>
                <div className='white-bg'>
                   
                    {ReusableDiv.PopupTitle("Register")}
                    <div>
                        <form>
                            <div className=" bs5 row">
                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="company_name" className='d-block'>Company Name (Not a company? Enter your full name)*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.company_name ? ' error' : ''}`} id="company_name"
                                            placeholder="Company Name" name="company_name"
                                            value={userDetail.company_name}
                                            onChange={({ target: { value } }) => onValueChange('company_name', value)} />
                                        {detailValidation.company_name && <p className="error"> {detailValidation.company_name}</p>}
                                    </div>
                                </div>

                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="telephone_number" className='d-block'>Phone Number*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.telephone_number ? ' error' : ''}`} id="telephone_number"
                                            placeholder="Phone Number" name="telephone_number"
                                            value={userDetail.telephone_number}
                                            onChange={({ target: { value } }) => onValueChange('telephone_number', value)} />
                                        {detailValidation.telephone_number && <p className="error"> {detailValidation.telephone_number}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className=" bs5 row">
                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="first_name" className='d-block'>First Name*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.first_name ? ' error' : ''}`} id="first_name"
                                            placeholder="First Name" name="first_name"
                                            value={userDetail.first_name}
                                            onChange={({ target: { value } }) => onValueChange('first_name', value)} maxLength={50} />
                                        {detailValidation.first_name && <p className="error"> {detailValidation.first_name}</p>}
                                    </div>
                                </div>

                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="last_name" className='d-block'>Last Name*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.last_name ? ' error' : ''}`} id="last_name"
                                            placeholder="Last Name" name="last_name"
                                            value={userDetail.last_name}
                                            onChange={({ target: { value } }) => onValueChange('last_name', value)} maxLength={50}/>
                                        {detailValidation.last_name && <p className="error"> {detailValidation.last_name}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className=" bs5 row">
                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="email_address" className='d-block'>Email Address*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.email_address ? ' error' : ''}`} id="email_address"
                                            placeholder="Email Address" name="email_address"
                                            value={userDetail.email_address}
                                            onChange={({ target: { value } }) => onValueChange('email_address', value)} maxLength={255}/>
                                        {detailValidation.email_address && <p className="error"> {detailValidation.email_address}</p>}
                                    </div>
                                </div>
                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                        <label htmlFor="confirmEmail" className='d-block'>Confirm Email*</label>
                                        <input type="text" className={`form-control ${detailValidation && detailValidation.confirm_email ? ' error' : ''}`} id="confirmEmail"
                                            placeholder="Email Address" name="confirmEmail"
                                            value={confirmEmail}
                                            onChange={({ target: { value } }) => onValueChange('confirmEmail', value)} maxLength={255} />
                                        {detailValidation.confirm_email && <p className="error"> {detailValidation.confirm_email}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className=" bs5 row">
                                <div className="col-6 mb-3">
                                    <div className="form-group">
                                    <label htmlFor="Country" className='d-block'>Country*</label>
                                        <select className={`form-control selectbox ${detailValidation && detailValidation.country ? ' error' : ''}`} aria-label="Country" id="country" name="country"
                                         onChange={({ target: { value } }) => onValueChange('country', value)}
                                          >
                                            <option value="">Country</option>
                                            {countryList?.length > 0 && countryList.map((v, i) => (
                                                <option key={v.countryId} value={v.storedValues}>{v.displayValues}</option>
                                            ))}
                                        </select>
                                        {detailValidation.country && <p className="error"> {detailValidation.country}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className='mb-3 d-flex align-items-center text-black'>
                                <input type="checkbox" className="form-check-input mt-0 me-2" id="customCheck1" name="email_updates"
                                 onChange={({ target: { checked } }) => onValueChange('email_updates', checked)} />
                                I would like to receive email updates from {System.getSpeedBoatName() === 'EBV' ? `${System.getSpeedBoatName()} Elektronik` : `Avnet ${System.getSpeedBoatName()}`}.
                            </div>
                            <div className='mb-3 text-black'>
                                <div className='d-flex align-items-center'>
                                <input type="checkbox" className={`form-check-input mt-0 ${detailValidation && detailValidation.privacy_policy ? ' error' : ''}`}
                                 id="customCheck2" name="privacy_policy" onChange={({ target: { checked } }) => onValueChange('privacy_policy', checked)} />*
                                By submitting this form, I confirm that I have read the&nbsp;<a target={"_blank"} href={System.getDataProtectionPolicy()} 
                            className='text-decoration-underline'>
                                   Privacy and Data Protection Policy
                                </a>&nbsp;of {System.getSpeedBoatName() === 'EBV' ? `${System.getSpeedBoatName()} Elektronik` : `Avnet ${System.getSpeedBoatName()}`},
                             and consent to my data being processed.
                                </div>
                                {detailValidation.privacy_policy && <p className="error"> {detailValidation.privacy_policy}</p>}
                            </div>
                            <p className='text-black'>Each Avnet.com user is solely responsible for maintaining the confidentiality of their password and for all activity conducted on their
                                Avnet.com account. If your password is lost, stolen or compromised you must immediately  contact {' '}
                                <a href="mailto:OnlineSupportEU@avnet.com" className='text-decoration-underline'>OnlineSupportEU@Avnet.com</a></p>
                        </form>
                    </div>
                    <div className="d-flex justify-content-center mt-5 mb-4">
                        <button type="button" className="bs5 btn btn-secondary w145" onClick={() => {if(!__check(['REGISTRATION_API_CALL']).status) { window.location.href = System.getPreviousPageUrl()}}}
                        >Cancel</button>
                        <button type="button" className="bs5 btn btn-primary ms-3 w145" onClick={() => !__check(['REGISTRATION_API_CALL']).status && onSubmit()}
                        > {__check(['REGISTRATION_API_CALL']).status ? <i className="fa add-cart-spinner fa-spin" /> : 'Submit'} </button>
                    </div>

                    <p className="d-flex mt-2 justify-content-center"> Already registered? &nbsp;
                        <a href={System.getLoginPageUrl()} className='text-decoration-underline'>{'  '}Sign In</a>
                    </p>
                </div>
                <div className='d-flex align-items-center justify-content-between'>
                    <a target={"_blank"} href={System.getHomepageUrl()} className='text-darkgreen mt-3 mb-3'>Continue to {System.getSpeedBoatName() === 'EBV' ? `${System.getSpeedBoatName()} Elektronik` : `Avnet ${System.getSpeedBoatName()}`}  Home</a>
                    <a target={"_blank"} href={System.getHelpPageUrl()} className='text-darkgreen mt-3 mb-3'>Help</a>
                </div>
            </div>

        </div>
    )
}

export default Registration
